import { useQuery } from '@hooks/reactQuery';

import { getRUStatusDashboardUsageState } from '@api/ruStatusDashboard';

import { mapDropdownOptions } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { RU_DASHBOARD_USAGE_STATE } from '@constants/queryKeys';

interface IUseQueryRUDashboardStatusUsageState {
	ruDashboardStatusUsageState: TSelectOption<string>[];
	isLoadingRUDashboardStatusUsage: boolean;
}

export const useQueryRUDashboardStatusUsageState = (): IUseQueryRUDashboardStatusUsageState => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [RU_DASHBOARD_USAGE_STATE],
		queryFn: getRUStatusDashboardUsageState,
		select: (data) => mapDropdownOptions({
			items: data,
			valueKey: 'name',
			labelKey: 'title',
		}),
		allowedRoles: [
			EUserRoles.smoLightUpdater,
			EUserRoles.smoLightViewer,
		],
		...refetchOptions,
	});

	return {
		ruDashboardStatusUsageState: data || [],
		isLoadingRUDashboardStatusUsage: isInitialLoading,
	};
};
